import script from "./PartnerKpiTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerKpiTable.vue?vue&type=script&setup=true&lang=js"

import "./PartnerKpiTable.vue?vue&type=style&index=0&id=61e85d86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61e85d86"]])

export default __exports__